<section class="personal-thrift">
    
    <section class="no-padding-top">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12">
                <div class="block">
                  <div class="title"><strong>Create A Personal Thrift</strong></div>
                  <!-- <button type="submit" class="btn btn-secondary">Cancel</button> -->
                  <div class="block-body">
                    <form  class="form-horizontal">
                      <div class="form-group row">
                        <label class="col-sm-3 form-control-label">Thrift Name</label>
                        <div class="col-sm-9">
                          <input type="text" 
                          class="form-control" 
                          formControlName="thriftName"
                          id="thriftName"
                          name="thriftName"
                          placeholder="Give your thrift a name" 
                          autocomplete="off" 
                          required>
                        </div>
                      </div>
                      <div class="line"></div>

                      <div class="form-group row">
                        <label class="col-sm-3 form-control-label">Description</label>
                        <div class="col-sm-9">
                          <input type="text" 
                          class="form-control"
                          formControlName="description"
                          id="description"
                          name="description" 
                          placeholder="Give a description on your thrift purpose" 
                          autocomplete="off" 
                          required>
                        </div>
                      </div>
                      <div class="line"></div>

                      <div class="form-group row">
                        <label class="col-sm-3 form-control-label">Amount</label>
                        <div class="col-sm-9">
                          <input type="text" 
                          class="form-control" 
                          formControlName="amount"
                          id="amount"
                          name="amount"
                          placeholder="Amount to be slotted in periodically" 
                          autocomplete="off" 
                          required>
                        </div>
                      </div>
                      <div class="line"></div>

                      <div class="form-group row">
                        <label class="col-sm-3 form-control-label">Atttainable Amount</label>
                        <div class="col-sm-9">
                          <input type="text" 
                          class="form-control" 
                          formControlName="attainableAmount"
                          id="attainableAmount"
                          name="attainableAmount"
                          placeholder="Total Amount You are Aiming" 
                          autocomplete="off" 
                          required>
                        </div>
                      </div>
                      <div class="line"></div>

                      <div class="form-group row">
                        <label class="col-sm-3 form-control-label">Start Date</label>
                        <div class="col-sm-9">
                          <input type="date" 
                          class="form-control" 
                          formControlName="startDate"
                          id="startDate"
                          name="startDate"
                          placeholder="Amount to be slotted in periodically" 
                          autocomplete="off" 
                          required>
                        </div>
                      </div>
                      <div class="line"></div>

                      <div class="form-group row">
                        <label class="col-sm-3 form-control-label">Duration</label>
                        <div class="col-sm-9">
                          <select 
                          formControlName="duration"
                          id="duration"
                          name="duration" 
                          class="form-control mb-3 mb-3"
                          required>
                            <option value="daily" >Daily</option>
                            <option value="weekly" >Weekly</option>
                            <option value="monthly" >Monthly</option>
                          </select>
                        </div>
                      </div>
                      <div class="line"></div>
                     
                      <div class="line"></div>
                      <div class="form-group row">
                        <div class="col-sm-9 ml-auto">
                         
                          <button type="submit" [disabled]="" class="btn btn-primary">Create Personal Thrift</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
          </div>
        </div>
    </section>
</section>